import { config } from '@config';
import { getEnvLabel } from '../../components/Header/envLabel';
import { getPersonaOverrideIds } from '@common/domain/persona-overrides';

export interface PersonaLike {
    id?: string;
    name?: string;
    devPersonaId?: string;
    localPersonaId?: string;
    dev_persona_id?: string;
    local_persona_id?: string;
}

export type Persona = PersonaLike;

export interface PersonaEnvironmentResolution {
    tavusPersonaId: string | undefined;
    isProdTavus: boolean;
}

export function resolvePersonaEnvironment(persona: PersonaLike | undefined, hostname?: string): PersonaEnvironmentResolution {
    if (!persona) {
        return { tavusPersonaId: undefined, isProdTavus: false };
    }
    const currentHost = hostname || (typeof window !== 'undefined' ? window.location.hostname : '');
    const envLabel = getEnvLabel(currentHost, config);

    const { devPersonaId: devId, localPersonaId: localId } = getPersonaOverrideIds(persona);

    let tavusPersonaId = persona.id;
    let hasOverride = false;

    if (envLabel === 'DEV') {
        if (devId) {
            tavusPersonaId = devId;
            hasOverride = true;
        }
    } else if (envLabel === 'LOCAL') {
        if (localId) {
            tavusPersonaId = localId;
            hasOverride = true;
        } else if (devId) {
            tavusPersonaId = devId;
            hasOverride = true;
        }
    }

    const isProdTavus = Boolean(envLabel && !hasOverride);

    return {
        tavusPersonaId,
        isProdTavus,
    };
}

export function getTavusPersonaId(persona: Persona | undefined, hostname?: string): string | undefined {
    return resolvePersonaEnvironment(persona, hostname).tavusPersonaId;
}

export function isPersonaUsingProdTavus(persona: Persona | undefined, hostname?: string): boolean {
    if (!persona) return false;
    return resolvePersonaEnvironment(persona, hostname).isProdTavus;
}

export function getPersonaDisplayName(
    persona: Persona | undefined,
    nameOverride?: string,
    hostname?: string
): string {
    if (!persona) return nameOverride || '';
    const base = nameOverride ?? persona.name ?? '';
    if (!base) return '';
    return isPersonaUsingProdTavus(persona, hostname) ? `${base} (PROD)` : base;
}
